import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertIcon } from '../../../design-system/alert';
import { GroupType } from '../../../entities/groups';
import { useUserCountMetadata } from '../../../queries/users';

type EligibilityCountProps = {
	conditions: { attr: string | undefined; value: string | undefined }[];
	operator: GroupType;
};

export const EligibilityCount: FC<EligibilityCountProps> = ({ conditions, operator }) => {
	const { t } = useTranslation('incentives', { keyPrefix: 'form' });

	const filteredConditions = useMemo(() => {
		return conditions.filter((condition) => condition.attr && condition.value) as { attr: string; value: string }[];
	}, [conditions]);

	const { data } = useUserCountMetadata({ conditions: filteredConditions, operator, status: 'active' });

	if (!data) {
		return null;
	}

	const context = data.scopedCount === data.totalCount ? 'unscoped' : 'scoped';

	return (
		<Alert status="info" size="sm" mb={4}>
			<AlertIcon />
			<AlertDescription>{t('audienceCount', { count: data.scopedCount, context })}</AlertDescription>
		</Alert>
	);
};
